// TypeFieldsTitleField.jsx

import React from 'react';

// Context
import { useTheme } from 'context/ThemeContext';

// CSS
import './TypeFieldsTitleField.css';

// Icons
import Icon from 'svg/Icon';

/**
 * TypeFieldsTitleField
 * 
 * Displayed as the first field in the type properties list, indicating the title field
 * which is always visible in the database view. 
 *  
 * @returns {ReactNode} - TypeFieldsTitleField component.
 */
const TypeFieldsTitleField = React.memo(() => {

    // ----- CONTEXT ----- //

    // Theme Context
    const { theme } = useTheme();

    // ----- RENDER ----- //

    return (

        <div className="type-fields-title-field-container"
            style={{
                backgroundColor: theme.panel,
                borderColor: theme.panel,
            }}>

            <div className="type-fields-title-field-row-main">

                {/* ICON */}
                <Icon
                    iconKey="title"
                    width={18}
                    height={18}
                    color={theme.foregroundMuted}
                />

                {/* LABEL */}
                <div
                    className="type-fields-title-field-row-label"
                    style={{
                        color: theme.foregroundMuted,
                    }}
                >
                    <div>Title</div>
                    <div className="type-fields-title-field-row-subtext">
                        (always visible)
                    </div>
                </div>

            </div>

        </div>
    );

});

// Dev Tools
TypeFieldsTitleField.displayName = 'TypeFieldsTitleField';

export default TypeFieldsTitleField;

